import {
  Button,
  ButtonGroup,
  ButtonGroupProps,
  ButtonProps,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useRef, useState } from 'react';

interface DropdownOption {
  label: string;
  onClick: () => void;
}

interface DropdownSplitButtonProps {
  buttonGroupProps?: ButtonGroupProps;
  buttonProps?: ButtonProps;
  dropDownButtonProps?: ButtonProps;
  options: DropdownOption[];
  defaultSelectedIndex?: number;
}

const DropdownSplitButton: React.FC<DropdownSplitButtonProps> = ({
  buttonGroupProps,
  buttonProps,
  dropDownButtonProps,
  options,
  defaultSelectedIndex = 0,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex);

  const handleMenuItemClick = (
    _event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    setOpen(false);
    options[index].onClick();
  };

  const handleMainButtonClick = () => {
    setOpen(false);
    options[selectedIndex].onClick();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup ref={anchorRef} {...buttonGroupProps}>
        <Button onClick={handleMainButtonClick} {...buttonProps}>
          {options[selectedIndex].label}
        </Button>
        <Button size="small" onClick={handleToggle} {...dropDownButtonProps}>
          <ArrowDropDownIcon
            sx={{
              transform: open ? 'rotate(180deg)' : 'rotate(0)',
              transition: 'transform 200ms ease-in-out',
            }}
          />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1, width: anchorRef.current?.offsetWidth }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option.label}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
};

export default DropdownSplitButton;
